import {
  ClickAwayListener,
  Divider,
  Fade,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Popper,
  Stack,
  Typography,
} from "@mui/material"
import { Box } from "@mui/system"
import dayjs from "dayjs"
import ErrorIcon from "@mui/icons-material/Error"
import InfScroll from "../ui/InfScroll"
import { useState, useEffect } from "react"
import { getNotifications } from "../../api"

export const NotificationsCard = ({
  open,
  handleClose,
  onClickNotficication,
  anchorRef,
}) => {
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [data, setData] = useState([])
  const fetchData = () => {
    getNotifications({
      page,
      sort: {
        field: "creationTimestamp",
        order: "desc",
      },
    })
      .then((res) => {
        setData(page === 1 ? res.data.rows : [...data, ...res.data.rows])
        setCount(res.data.count)
        setTotalPages(Math.max(res.data.totalPages, 1))
      })
      .catch((err) => {
        setTotalPages(page)
        console.log(err)
      })
  }
  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  useEffect(() => {
    if (open) {
      if (page === 1) fetchData()
      else setPage(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])
  return (
    <Popper
      disablePortal
      anchorEl={anchorRef.current}
      open={open}
      placement={"bottom-end"}
      role={undefined}
      transition
      style={{ zIndex: "1" }}
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={150}>
          <Paper
            sx={{
              p: 0,
              width: {
                sm: "500px",
                xs: "100%",
              },
              maxHeight: "90vh",
              overflowY: "scroll",
              maxWidth: "100%",
            }}
            id="notif-box"
          >
            <ClickAwayListener onClickAway={handleClose}>
              <Box>
                <List
                  id="composition-menu"
                  aria-labelledby="composition-button"
                >
                  <InfScroll
                    count={count}
                    next={() => setPage(page + 1)}
                    hasMore={page !== totalPages}
                    target="notif-box"
                  >
                    {data.map((notif, i) => (
                      <>
                        <ListItem sx={{ p: 0 }}>
                          <ListItemButton
                            onClick={() => onClickNotficication(notif)}
                            sx={{ opacity: !notif.isRead ? "1" : "0.55" }}
                          >
                            <Stack
                              direction="row"
                              justifyContent={"space-between"}
                              sx={{ width: "100%" }}
                            >
                              <ErrorIcon sx={{ mr: 1, mt: 0.4 }} />

                              <Stack gap={0.5} sx={{ flexGrow: 1 }}>
                                <Typography variant="h6" fontSize={18}>
                                  {notif.title}
                                </Typography>
                                <Typography variant="body2">
                                  {notif.content}
                                </Typography>
                              </Stack>
                              <Typography fontSize={14} sx={{ flex: "none" }}>
                                {dayjs().diff(dayjs(notif.createdAt), "days") +
                                  " days"}
                              </Typography>
                            </Stack>
                          </ListItemButton>
                        </ListItem>

                        <Divider sx={{ width: "100%", margin: "0 auto" }} />
                      </>
                    ))}
                  </InfScroll>
                </List>
              </Box>
            </ClickAwayListener>
          </Paper>
        </Fade>
      )}
    </Popper>
  )
}
